module.exports = __webpack_public_path__ + "static/media/tata_motors_logo.2caf9a55.png";